var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{attrs:{"cards":_vm.openCards}}),_c('div',[(_vm.sentCards && _vm.sentCards.length)?_c('div',{staticClass:"title my-3"},[_vm._v("To be claimed cards")]):_vm._e(),_c('List',{attrs:{"cards":_vm.sentCards}})],1),_c('GiftCardDetail'),(_vm.isEmpty)?_c('EmptyView',{attrs:{"text":"Gift Card Wallet is Empty"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }